import { Component } from "react";

import FieldProLogger from "log/FieldProLogger";

import FallbackScreen from "components/Errors/FallbackScreen";
import {
  IErrorBoundaryProps,
  IErrorBoundaryState,
} from "model/application/Container";

export default class LoginErrorBoundary extends Component<
  IErrorBoundaryProps,
  IErrorBoundaryState
> {
  constructor(props: IErrorBoundaryProps) {
    super(props);

    this.state = {
      hasError: false,
      error: undefined,
      info: undefined,
    };
  }

  /**
   * Catches errors thrown by children
   * @param {Object} error Error thrown
   * @param {Object} info Information of the error Thrown
   * */
  componentDidCatch(error: any, info: any) {
    const { client, user } = this.props;
    const logger = FieldProLogger({
      client,
      user,
    });
    logger.logError(error);
    this.setState({
      hasError: true,
    });

    // TODO log these to external service
    console.error("Error Caught Info", JSON.stringify(info));
    console.error("Error Caught, Error", JSON.stringify(error));
  }

  render() {
    if (this.state.hasError) {
      // An appropriate error message
      // render a custom fallback UI
      return <FallbackScreen />;
    }

    // render children if there is no error
    return this.props.children;
  }
}
